import React from 'react';

export interface BarcodeStatusDotProps {
  status: string;
}

const COLORS: Record<string, string> = {
  confirmed: 'var(--positive)',
  pending: 'var(--warning)',
  unconfirmed: 'var(--text-tertiary)',
};

/** Small colored dot indicating barcode verification status. */
export const BarcodeStatusDot: React.FC<BarcodeStatusDotProps> = ({ status }) => (
  <div
    style={{
      width: 6,
      height: 6,
      borderRadius: '50%',
      background: COLORS[status] || 'var(--text-tertiary)',
    }}
    title={`Barcode: ${status}`}
  />
);
